import { render } from "./Pinger.vue?vue&type=template&id=5f98cc29"
import script from "./Pinger.vue?vue&type=script&lang=ts"
export * from "./Pinger.vue?vue&type=script&lang=ts"
script.render = render

export default script